import PropTypes from 'prop-types';

/* eslint-disable max-len */

const LocationIcon = ({
  dataTestId = 'locationIcon',
  viewBox = '0 0 30 30',
  height = '30px',
  width = '30px',
  fill,
}) => (
  <svg
    width={width}
    height={height}
    viewBox={viewBox}
    data-testid={dataTestId}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15 3C10.032 3 6 6.584 6 11C6 15.416 15 27 15 27C15 27 24 15.416 24 11C24 6.584 19.968 3 15 3ZM15 13.4C13.506 13.4 12.3 12.328 12.3 11C12.3 9.672 13.506 8.6 15 8.6C16.494 8.6 17.7 9.672 17.7 11C17.7 12.328 16.494 13.4 15 13.4Z"
      stroke={fill}
      strokeWidth="1.5"
      strokeMiterlimit="10"
    />
  </svg>
);
LocationIcon.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  fill: PropTypes.string.isRequired,
  dataTestId: PropTypes.string,
  viewBox: PropTypes.string,
};
export default LocationIcon;
